// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"26":"map-view","114":"order-new","348":"chat","386":"order-detail"}[chunkId] + "." + {"26":"54c64277","114":"7a000112","348":"382d2a5b","386":"51d54497"}[chunkId] + ".css";
};